import React, { useContext } from 'react'
import { AppContext } from '../../../App'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { prepareProductUrl } from '../../../services/helpers'
import { missingImageUrl } from '../../../config.json'

export default function AdhesivesProduct({ coverage, adhesiveName, productImage, shortDescription, subheading, productUrl, trowelCoverage }) {
   const {
      setCurrentStep,
      setAppHeader,
      setNavState,
      setLinkGoBackTarget,
      productOptionsSelected,
      stepsCompleted,
      setStepsCompleted,
      setProductOptionsSelected,
      setProductCoverage,
      setProductSelected
   } = useContext(AppContext)

   const { productOptions } = productOptionsSelected
    const iconAngleRight = <FontAwesomeIcon icon={faAngleRight} color="#00a8d5" />

   const handleProductSelected = () => {
      // Set the selected product as productSelected
       setProductSelected({ adhesiveName, productImage, shortDescription, trowelCoverage: trowelCoverage })
      // Update the current step
      setCurrentStep({ step: "adhesivesCoverageDetails" })
      // Update the nav state
      setNavState({ navStep: "AdhesivesProductSelection" })
      // Set the appHeader for Step state
      setAppHeader("Step 2 of 2")
      // Set the Go Back link
      setLinkGoBackTarget({ link: "adhesivesProductSelection" })
      // Update the steps completed to include this step.
      stepsCompleted.push("Choose an Adhesive")
      setStepsCompleted(stepsCompleted)
      // Add the selected grout product to state of App
       productOptions.push(adhesiveName)
      setProductOptionsSelected({ productOptions: productOptions })
       setProductCoverage(coverage)
       
   }

   const imgUrlBase = 'https://cdn.laticrete.com/'
   const imgUrl = productImage ? imgUrlBase + productImage : missingImageUrl

   return (   
       <div className="list-item" key={adhesiveName }>
         <div className="row p-1">
            <div className="col-xs-12 col-sm-3 hidden-xs">
               <figure className="system-image">
                       <img alt={adhesiveName || shortDescription || productImage } src={ imgUrl } className="img-responsive" />
               </figure>
            </div>
            <div className="col-xs-12 col-sm-9">
               <div className="row p-1">
                  <div className="col-xs-12 visible-xs">
                     <figure className="system-image">
                               <img alt={adhesiveName || shortDescription || productImage } src={ imgUrl } className="img-responsive" />
                     </figure>
                  </div>
                  <div className="col-xs-12 col-sm-8 col-lg-9">
                           {adhesiveName && <h4>{adhesiveName } { subheading && <small>{ subheading }</small> }</h4> }
                     { shortDescription && <p dangerouslySetInnerHTML={{ __html: shortDescription }}></p> }
                  </div>
                  <div className="col-xs-12 col-sm-4 col-lg-3 hidden-xs">
                     <button className="btn btn-primary btn-block" onClick={() => handleProductSelected()}>SELECT</button>
                  </div>
               </div>
               <div className="row p-1">
                  <div className="col-xs-12">
                     { productUrl && 
                        <a href={ prepareProductUrl(productUrl) } rel="noopener noreferrer" target="_blank">Learn More{ iconAngleRight }</a>
                     }
                     <button className="btn btn-primary btn-block visible-xs" onClick={() => handleProductSelected()}>SELECT</button>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/adhesives/AdhesivesProduct.js